import * as React from 'react';
import { SVGProps } from 'react';

const SvgExpand = (props: SVGProps<SVGSVGElement>) => (
  <svg {...props} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <path d="m9.867 12.685 1.443 1.443-2.857 2.857 2.814 2.814-7.043-.029-.029-7.043 2.814 2.814 2.857-2.857zm4.288-1.378-1.443-1.443 2.857-2.857-2.814-2.814 7.041.027.03 7.044-2.814-2.814-2.857 2.857z" />
  </svg>
);

export default SvgExpand;
